import React from 'react';

class ShowIf extends React.Component {

  render() {
    if (this.props.condition) {
      if (typeof this.props.children.length != "undefined") {
        return (
          <div>
            {this.props.children}
          </div>
        )
      } else return this.props.children;

    } else {
      return null;
    }
  }
}

ShowIf.defaultProps = {
  condition: true
}

export default ShowIf;



// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/ShowIf.jsx